import { useState, useEffect, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { REVIEWS } from "@/data/content";

export default function Reviews() {
  const [emblaRef, embla] = useEmblaCarousel({ loop: true, align: "start" });
  const [selected, setSelected] = useState(0);

  const onSelect = useCallback(() => { if (embla) setSelected(embla.selectedScrollSnap()); }, [embla]);
  useEffect(() => {
    if (!embla) return;
    embla.on("select", onSelect);
    const id = setInterval(() => embla.scrollNext(), 5000);
    return () => clearInterval(id);
  }, [embla, onSelect]);

  return (
    <section id="reviews" className="bg-charcoal text-cream py-28 md:py-36 grain relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-terracotta text-xs uppercase tracking-[0.25em] mb-5">Loved by Locals</p>
            <h2 className="font-serif-display text-5xl md:text-6xl">4.7 on Grubhub<span className="text-terracotta">.</span></h2>
            <div className="flex items-center gap-1 mt-3">
              {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-terracotta text-terracotta" />)}
              <span className="text-cream/60 text-sm ml-2">350+ ratings</span>
            </div>
          </div>
          <div className="flex gap-3">
            <button onClick={() => embla?.scrollPrev()} data-testid="reviews-prev" className="h-12 w-12 rounded-full border border-cream/25 flex items-center justify-center hover:bg-cream/10 transition-colors"><ChevronLeft /></button>
            <button onClick={() => embla?.scrollNext()} data-testid="reviews-next" className="h-12 w-12 rounded-full border border-cream/25 flex items-center justify-center hover:bg-cream/10 transition-colors"><ChevronRight /></button>
          </div>
        </div>

        <div className="overflow-hidden" ref={emblaRef} data-testid="reviews-carousel">
          <div className="flex gap-6">
            {REVIEWS.map((r, i) => (
              <div key={i} className="min-w-0 shrink-0 basis-full md:basis-[46%] lg:basis-[38%]">
                <div className="bg-cream/5 border border-cream/10 rounded-lg p-8 h-full">
                  <Quote className="text-terracotta mb-4" />
                  <p className="font-serif-display text-2xl leading-snug text-cream/90">"{r.text}"</p>
                  <div className="mt-6 flex items-center gap-1">
                    {[...Array(r.rating)].map((_, k) => <Star key={k} size={14} className="fill-terracotta text-terracotta" />)}
                  </div>
                  <p className="mt-3 text-cream/60 text-sm">— {r.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {REVIEWS.map((_, i) => (
            <button key={i} onClick={() => embla?.scrollTo(i)} aria-label={`Go to review ${i + 1}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${selected === i ? "w-8 bg-terracotta" : "w-2 bg-cream/30"}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
